var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 13.6185C4 10.0066 5.6857 6.54272 8.6863 3.98876C11.6869 1.4348 15.7565 0 20 0C24.2434 0 28.3132 1.4348 31.3138 3.98876C34.3142 6.54272 36 10.0066 36 13.6185V21.6142L40 26.7212V34.0462H28.778C28.323 35.7378 27.2072 37.248 25.6128 38.3294C24.0182 39.411 22.0398 40 20.001 40C17.9622 40 15.9837 39.411 14.3893 38.3294C12.7949 37.248 11.6789 35.7378 11.224 34.0462H0V26.7212L4 21.6142V13.6185ZM15.416 34.0462C15.8048 34.8058 16.4456 35.4524 17.2599 35.9064C18.0742 36.3606 19.0265 36.6024 20 36.6024C20.9734 36.6024 21.9258 36.3606 22.7402 35.9064C23.5544 35.4524 24.1952 34.8058 24.584 34.0462H15.416ZM20 3.40462C16.8174 3.40462 13.7652 4.48072 11.5147 6.3962C9.26428 8.31166 8 10.9096 8 13.6185V22.6458L4 27.7528V30.6416H36V27.7528L32 22.6458V13.6185C32 10.9096 30.7358 8.31166 28.4852 6.3962C26.2348 4.48072 23.1826 3.40462 20 3.40462Z",
    fill: "#A6A6A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification1);
export default __webpack_public_path__ + "static/media/notification_1.3ac98cbd4a14af4e8ef016123b746666.svg";
export { ForwardRef as ReactComponent };